<template>
  <div class="footer__wrp">
    <div class="d-flex footer__flex">
      <div class="flex-item footer__item mr-auto">{{ $bimTranslate('signUp.bim', activeLang) }}</div>
      <a
        class="licence__link footer__item footer__item--hover flex-auto"
        href="https://bimlib.pro/agreement/"
        target=_blank
      >
        {{ $bimTranslate('signUp.agreement', activeLang) }}
      </a>
      <a
        class="licence__link footer__item footer__item--hover flex-auto"
        href="https://bimlib.pro/privacy/"
        target=_blank
      >
        {{ $bimTranslate('signUp.privacyPolicy', activeLang) }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsBlock',
  props: {
    activeLang: String
  }
}
</script>

<style lang="scss" scoped>
.footer__wrp {
  margin: 0 30px;
  padding-bottom: 42px;
  color: #4d4d4d;
  padding-top: 30px;
}
.footer__flex {
  display: flex;
}
.footer__item {
  opacity: .35;
}

.footer__item--hover {
  transition: all .2s;
}
.footer__item--hover:hover {
  opacity: 1;
}
.licence__link {
  color: inherit;
  text-decoration: none;
}
.licence__link + .licence__link {
  margin-left: 24px;
}
@media all and (max-width: 1000px) {
  .footer__flex {
    display: block;
    text-align: center;
  }
  .footer__item + .footer__item {
    margin-top: 8px;
    display: block;
  }
  .licence__link + .licence__link {
    margin-left: 0;
  }
}
</style>
